import { Modal, ModalProvider } from '@joor/design-system'
import styled from 'styled-components'

import ModalActions from './components/ModalActions/ModalActions'
import ReassignActions from './components/ReassignActions/ReassignActions'
import RemoveWarning from './components/RemoveWarning/RemoveWarning'
import SourceUserDropdown from './components/SourceUserDropdown/SourceUserDropdown'
import TargetUserDropdown from './components/TargetUserDropdown/TargetUserDropdown'
import { useReassignConnectionsModal } from './reassignConnectionsModal.hooks'
import IDs from './reassignConnectionsModal.ids'
import messages from './reassignConnectionsModal.messages'

export const StyledModal = styled(Modal)`
  overflow: unset;
  > div:first-of-type {
    overflow-y: unset;
  }
  > div:last-child {
    margin-top: 20px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export interface ReassignConnectionsProps {
  onClose: () => void
  selectedUserId?: string
}

const ReassignConnectionsModal = ({
  onClose,
  selectedUserId,
}: ReassignConnectionsProps) => {
  const {
    isConfirmDisabled,
    isLoading,
    isReassigning,
    optionGroups,
    sourceUser,
    handleConfirm,
    handleOnClose,
    Portal,
    activeSalesRepOptions,
    action,
  } = useReassignConnectionsModal(onClose)

  return (
    <Portal>
      <ModalProvider>
        <StyledModal
          closeIconId={IDs.CloseButton}
          onClose={handleOnClose}
          title={{
            id: IDs.Title,
            text: messages.modalTitle.replace(
              '{amount}',
              sourceUser ? `${sourceUser.numberConnections}` : '',
            ),
            iconName: 'person',
          }}
          isOpen
          size="medium"
          disableBackgroundClick
        >
          <Modal.Content>
            <Container>
              <SourceUserDropdown
                options={optionGroups}
                isLoading={isLoading}
                selectedUserId={selectedUserId}
              />
              <ReassignActions isLoading={isLoading} />
              <TargetUserDropdown
                options={activeSalesRepOptions}
                isLoading={isLoading}
              />
              <RemoveWarning />
            </Container>
          </Modal.Content>
          <Modal.Actions>
            <ModalActions
              isConfirmDisabled={isConfirmDisabled}
              isReassigning={isReassigning}
              handleConfirm={handleConfirm}
              handleOnClose={handleOnClose}
              action={action}
            />
          </Modal.Actions>
        </StyledModal>
      </ModalProvider>
    </Portal>
  )
}

export default ReassignConnectionsModal
